module.exports = __webpack_public_path__ + "img/profile_sp.22e72033.png";